const root = document.documentElement;
  const section = document.querySelector('.viewport-fix');

  let BASE_RADIUS, MAX_RADIUS, BASE_SCALE, MAX_SCALE;
  const DELAY_SCROLL = 500;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setResponsiveValues() {
    if (window.innerWidth < 768) {
        BASE_RADIUS = 130;
        MAX_RADIUS = 260;
        BASE_SCALE = 0.8;
        MAX_SCALE = 1.2;
    } else {
        BASE_RADIUS = 420;
        MAX_RADIUS = 800; 
        BASE_SCALE = 1;
        MAX_SCALE = 1.6; 
    }
    updateOrbit(); 
  }

  function updateOrbit() {
    if (!section) return;

    const scrollY = window.scrollY;
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    const windowHeight = window.innerHeight;

    const triggerPoint = sectionTop - windowHeight / 2;
    const endPoint = sectionTop + sectionHeight - windowHeight / 2;

    if (scrollY < triggerPoint + DELAY_SCROLL) {
      root.style.setProperty('--radius', `${BASE_RADIUS}px`);
      root.style.setProperty('--img-scale', BASE_SCALE);
      return;
    }

    if (scrollY > endPoint) {
      root.style.setProperty('--radius', `${MAX_RADIUS}px`);
      root.style.setProperty('--img-scale', MAX_SCALE);
      return;
    }

    const relativeScroll = scrollY - triggerPoint - DELAY_SCROLL; 
    const totalScroll = endPoint - triggerPoint - DELAY_SCROLL; 

    let progress = relativeScroll / totalScroll;
    progress = clamp(progress, 0, 1);

    const radius = clamp(BASE_RADIUS + (MAX_RADIUS - BASE_RADIUS) * progress, BASE_RADIUS, MAX_RADIUS);
    const scale = clamp(BASE_SCALE + (MAX_SCALE - BASE_SCALE) * progress, BASE_SCALE, MAX_SCALE);

    root.style.setProperty('--radius', `${radius}px`);
    root.style.setProperty('--img-scale', scale);
  }

  setResponsiveValues();

  window.addEventListener('scroll', updateOrbit);
  window.addEventListener('resize', setResponsiveValues);